export default "__VITE_ASSET__DOAweChy__"